import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

export default class Animate extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    show: PropTypes.bool,
  }

  static defaultProps = {
    show: true,
    timeout: {enter: 500, exit: 1000},
  }

  ensureChildArray(children) {
    return (Array.isArray(children) ? children : [children]).filter(x => !!x);
  }

  render() {
    const {show, children, ...transProps } = this.props;
    const items = show ? this.ensureChildArray(children) : [];

    return (
      <TransitionGroup className="animate-component">
        {items.map((item, i) => (<CSSTransition key={i} {...transProps}>{item}</CSSTransition>))}
      </TransitionGroup>
    );
  }
}
